import React from "react"
import { Modal, Button, Space } from "antd"
import { useTranslation } from "react-i18next"

export interface SurveyModalProps {
	title: React.ReactNode
	open: boolean
	onCancel: () => void
	children: React.ReactNode
	footer?: React.ReactNode[]
	width?: number
	maxHeight?: number
	loading?: boolean
}

const SurveyModal: React.FC<SurveyModalProps> = ({
	title,
	open,
	onCancel,
	children,
	footer,
	width = 900,
	maxHeight = 500,
	loading = false
}) => {
	const { t } = useTranslation("common")

	const defaultFooter = [
		<Button key="close" onClick={onCancel} disabled={loading}>
			{t("close")}
		</Button>
	]

	return (
		<Modal
			title={title}
			open={open}
			onCancel={onCancel}
			footer={footer || defaultFooter}
			width={width}
			styles={{
				body: {
					maxHeight: `${maxHeight}px`,
					overflowY: "auto"
				}
			}}
			destroyOnClose
		>
			{children}
		</Modal>
	)
}

export default SurveyModal
